import { transformParamsToCrudApi } from '@app/core/crud/listing-adapter';
import { convertGetManyResponse } from '@app/core/crud/response-converter';
import { ListViewQueryParams } from '@app/core/list-view/types';
import { youtubeIntegrationListCuepoints } from '@mi-front/api-v2';
import { cleanQuery, Paginated } from '@mi-front/core';
import { YOUTUBE_CUEPOINTS_FILTERS_CONFIG } from '../filters/youtube-cuepoints-filters-config';
import { CuepointDto } from './youtube-cuepoints-api.types';

/**
 * Fetches paginated YouTube cuepoints for a station via youtube-integration CRUD list params.
 */
export async function fetchYoutubeCuepoints(
  stationId: string,
  params: ListViewQueryParams,
  timezone: string,
): Promise<Paginated<CuepointDto>> {
  const crudParams = transformParamsToCrudApi(params, {
    filterDefinitions: YOUTUBE_CUEPOINTS_FILTERS_CONFIG,
    context: { timezone },
  });

  const response = await youtubeIntegrationListCuepoints(
    cleanQuery({
      ...crudParams,
      filter: [...(crudParams.filter ?? []), `stationId||eq||${stationId}`],
    }),
  );

  return convertGetManyResponse(response);
}
